import Seo from "../components/common/Seo";
import { buildPath } from "../utils/routing";
import { t } from "../i18n/messages";

export default function ForbiddenPage({ locale }) {
  return (
    <>
      <Seo
        locale={locale}
        title={`Chronos Arte Node | ${t(locale, "forbiddenTitle")}`}
        description={t(locale, "forbiddenDesc")}
        path={buildPath(locale, "forbidden")}
      />

      <div className="forbidden-overlay">
        <div className="forbidden-card">
          <h1>{t(locale, "forbiddenTitle")}</h1>
          <p className="forbidden-desc">{t(locale, "forbiddenDesc")}</p>
          <p>{t(locale, "forbiddenBody1")}</p>
          <p>{t(locale, "forbiddenBody2")}</p>
        </div>
      </div>
    </>
  );
}
